import * as Rx from 'rxjs';

import { sendHelpRequest, userEmailRequest, userEmailResponse } from './types';

import apiService from '../api';
import RxOp from 'rxjs-operators';
import IUserToken from 'interfaces/tokens/userToken';
import logService from 'services/log';
import { COOKIE_DOMAIN } from 'settings';

const ONE_YEARS_IN_SECONDS = 60 * 60 * 24 * 365;

// eslint-disable-next-line no-var
declare var gtag: (command: string, commandOrValue: any | string, value?: any) => void;
export class UserService {
  private user$: Rx.BehaviorSubject<IUserToken>;

  constructor() {
    this.user$ = new Rx.BehaviorSubject(null);
  }

  public getUser(): Rx.Observable<IUserToken> {
    return this.user$.asObservable();
  }

  public setUser(user: IUserToken): Rx.Observable<IUserToken> {
    this.user$.next(user);

    logService.setUser(user);

    gtag('config', process.env.REACT_APP_GOOGLE_ANALYTICS_ID, {
      page_path: document.location.pathname,
    });

    const hasCookie = document.cookie
      .split('; ')
      .find(row => row.startsWith('blk_user='))
      ?.split('=')[1];

    if (!hasCookie) {
      document.cookie = `blk_user=${user?.id};domain=${COOKIE_DOMAIN};path=/;max-age=${ONE_YEARS_IN_SECONDS}`;
    }

    return Rx.of(user);
  }

  public getUserDetailByEmail(model: userEmailRequest): Rx.Observable<userEmailResponse> {
    return apiService.post('user/detail_by_email', model).pipe(RxOp.map(response => response.data[0]));
  }

  public sendHelp(helpData: sendHelpRequest): Rx.Observable<any> {
    const { eventId, ...data } = helpData;
    return apiService.post(`help_services/helpsend/${eventId}`, data);
  }
}

const userService = new UserService();
export default userService;
